<template>
  <NuxtLayout>
    <div class="partys_page">
      <div class="nav_banner">
        <img src="../../assets/partys_banner.png" alt="">
      </div>
      <div style="display: flex;align-items: center;margin: 0 auto;padding-top: 20px;box-sizing: border-box; background-color: #ffffff;">
        <el-select v-model="dateValue" size="large" style="width: 100px;box-shadow: none;" @change="dateChange">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
        <div class="line"></div>
        <DatePicker :currentDate="currentDate" :daysInCurrentMonth="daysInCurrentMonth" :monthDate="monthDate" :upContentList="upContentList" @upDay="upDay"/>
      </div>
      <!-- 内容 -->
      <Content :oneContentObj="oneContentObj" />
    </div>
  </NuxtLayout>
</template>
<script>
import DatePicker from '../../components/partys/DatePicker';
import Content from './content';
import { shopHistoryList } from "@/api/partys";
import { ref, onMounted, defineComponent, reactive } from 'vue';
import cookie from '@/utils/cookies'
export default defineComponent({
  components: {
    DatePicker,
    Content
  },
  setup() {
    const cookieData = cookie.getShop()
    useHead({
      title: "党史资源-" + cookieData.shopName,
    });
    const dateValue = ref('')
    const options = [
      {
        value: '01月',
        label: '01月',
      },
      {
        value: '02月',
        label: '02月',
      },
      {
        value: '03月',
        label: '03月',
      },
      {
        value: '04月',
        label: '04月',
      },
      {
        value: '05月',
        label: '05月',
      },
      {
        value: '06月',
        label: '06月',
      },
      {
        value: '07月',
        label: '07月',
      },
      {
        value: '08月',
        label: '08月',
      },
      {
        value: '09月',
        label: '09月',
      },
      {
        value: '10月',
        label: '10月',
      },
      {
        value: '11月',
        label: '11月',
      },
      {
        value: '12月',
        label: '12月',
      },
    ]
    // 请求获取的内容
    const contentList = ref([])
    // 重组数组
    const upContentList = ref([])

    // 单个内容
    const oneContentObj = ref({})

    const currentDate = ref(0);
    const seleDate = ref('')
    const daysInCurrentMonth = ref(0);
    const monthDate = ref(0)
    const myDay = ref('')
    // 当前年份
    const currentYear = ref(new Date().getFullYear());

    onMounted(() => {
      const now = new Date();
      currentDate.value = now.getDate();
      seleDate.value = currentDate.value
      // 获取当前月份的天数
      const year = now.getFullYear();
      const month = now.getMonth() + 1; // 月份是从0开始的，所以需要加1
      daysInCurrentMonth.value = new Date(year, month, 0).getDate();
      monthDate.value = month
      dateValue.value = options[parseInt(monthDate.value) - 1].value
      postShopHistoryList()
      myContent()
    });
    const myContent = () => {
      for (let i = 0; i < daysInCurrentMonth.value; i++) {
        let obj = {
          id: i,
          day: i + 1,
          title: "",
          historyBody: "",
          releaseDate: "",
          historySource: ""
        }

        upContentList.value.push(obj)
      }
    }

    async function postShopHistoryList() {
      await shopHistoryList({
        releaseDate: currentYear.value + '-' + dateValue.value.slice(0, 2)
      }).then((res) => {
        if (res) {
          contentList.value = res
          let arr = contentList.value.map(item => {
            const day = item.releaseDate.split('-')[2]
            return { ...item, day: day }
          })
          upContentList.value.forEach((item1) => {
            const match = arr.find(item2 => item1.day == item2.day)
            if (match) {
              item1.title = match.title
              item1.historyBody = match.historyBody
              item1.releaseDate = match.releaseDate
              item1.historySource = match.historySource
            }
          })
          oneContentObj.value = {}
          oneContentObj.value = upContentList.value[seleDate.value - 1]
        }
      }).catch((err) => {
        console.log(err);
      })
    }

    const upDay = (val) => {
      myDay.value = val
      oneContentObj.value = {}
      seleDate.value = myDay.value
      oneContentObj.value = upContentList.value[myDay.value - 1]
    }
    const dateChange = (e) => {
      monthDate.value = parseInt(e)
      daysInCurrentMonth.value = new Date(currentYear.value, monthDate.value, 0).getDate()
      upContentList.value.length = 0
      postShopHistoryList()
      for (let i = 0; i < daysInCurrentMonth.value; i++) {
        let obj = {
          id: i,
          day: i + 1,
          title: "",
          historyBody: "",
          releaseDate: "",
          historySource: ""
        }

        upContentList.value.push(obj)
      }
      currentDate.value = 1
      
    }

    return {
      dateValue,
      options,
      upContentList, 
      oneContentObj,
      monthDate,
      currentDate,
      seleDate,
      myDay,
      currentYear,
      daysInCurrentMonth,
      contentList,
      upDay,
      myContent,
      dateChange,
      postShopHistoryList,
    };
  }
})
</script>
<style scoped lang="scss">
.partys_page {
  width: 1200px;
  margin: auto;
}

.nav_banner {
  width: 1200px;
  margin: auto;
  height: auto;
}

.line {
  width: 1px;
  height: 50px;
  border: 1px solid #EEEEEE;
  margin-right: 20px;
}

::v-deep .el-input__wrapper {
  box-shadow: none !important;
  background-color: initial;
}

::v-deep .el-input__wrapper:hover {
  box-shadow: 0 0 0 0 !important;
}

::v-deep .el-select .el-input.is-focus .el-input__wrapper {
  box-shadow: 0 0 0 0 !important;
}

::v-deep .el-select .el-input__wrapper.is-focus {
  box-shadow: 0 0 0 0 !important;
}

::v-deep .el-input--large {
  font-size: 16px;
  font-weight: 1000;
}
</style>
